// extracted by mini-css-extract-plugin
export default {"container":"topNav_container__TYZkE","navWrapper":"topNav_navWrapper__VOdQg","marquee":"topNav_marquee__j0gso","marqueeSpan":"topNav_marqueeSpan__8SZia"};